import React, { useEffect, useState } from "react";
import {
  applyDocumentTheme,
  resolveAuthenticationTheme,
  ThemePreference,
} from "../../../utilities/themePreference";
import "./AuthenticationTheme.css";

interface AuthenticationThemeBoundaryProps {
  children: React.ReactNode;
}

const AuthenticationThemeBoundary: React.FC<AuthenticationThemeBoundaryProps> = ({ children }) => {
  const [theme, setTheme] = useState<ThemePreference>(resolveAuthenticationTheme);

  useEffect(() => {
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)");
    const syncTheme = () => setTheme(resolveAuthenticationTheme());

    systemTheme.addEventListener("change", syncTheme);
    window.addEventListener("storage", syncTheme);

    return () => {
      systemTheme.removeEventListener("change", syncTheme);
      window.removeEventListener("storage", syncTheme);
    };
  }, []);

  useEffect(() => {
    // Tailwind's dark: utilities resolve from the document root, while the
    // authentication palette is scoped to this boundary. Keep both in sync so
    // account changes cannot leave images or other utilities on a stale theme.
    applyDocumentTheme(theme);
  }, [theme]);

  return (
    <div
      className={`authentication-theme ${theme === "dark" ? "dark" : ""}`}
      data-theme={theme}
    >
      {children}
    </div>
  );
};

export default AuthenticationThemeBoundary;
